<template>
  <div
    v-if="filter?.options?.length"
    class="filter-links"
  >
    <!--
    <h2 class="heading heading--4 filter-links__title">
      {{ filter.label }}
    </h2>
    -->
    <UiScrollable
      class="filters-links__scrollable"
      axis="x"
    >
      <ul class="filter-links__list">
        <li class="filter-links__item filter-links__item--all">
          <span class="filter-links__current">
            {{ $t('All') }}
          </span>
        </li>
        <FilterLinksItem
          v-for="option in getRootCategoryList"
          :key="option.key"
          :option="option"
          :filter="filter"
          class="filter-links__item"
          :class="{ 'filter-links__item--active': option.active }"
        />
      </ul>
    </UiScrollable>

    <!-- <pre>filter: {{ filter }}</pre> -->
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  filter: {
    type: Object,
    required: true,
  },
})

const getRootCategoryList = computed<any[]>(() => {
  const categoryRoot = props.filter.options.find((item: any) => getActiveRootCategory(item))
  return categoryRoot ? categoryRoot.children : props.filter.options
})

const getActiveRootCategory = (item: any): any | null => {
  if (item.active === true) {
    return item
  }
  for (const i in item.children) {
    const childIsRoot = getActiveRootCategory(item.children[i])
    if (childIsRoot) {
      return childIsRoot.children.length ? childIsRoot : item
    }
  }
  return null
}
</script>

<style>
@import url("~layers/app/components/Filter/Links.css");
</style>
